import { type GetEventsResponseObject } from '../../repositories/conversationRepository';

import type { ZustandStore } from '../store.type';
import type { NamedSet } from 'zustand/middleware';

type StreamState = {
	stream: {
		initialAfter: number;
		streamData: GetEventsResponseObject;
		currentStreamData: GetEventsResponseObject;
	};
};

type StreamActions = {
	setStreamData: (data: GetEventsResponseObject) => void;
	setCurrentStreamData: (data: GetEventsResponseObject) => void;
};

export type StreamSlice = StreamState & StreamActions;

const streamInitialState = () => {
	const initialAfter = Date.now();
	const initialData = { events: [], lastTimestamp: initialAfter };
	return {
		stream: {
			initialAfter,
			streamData: initialData,
			currentStreamData: initialData,
		},
	};
};

export function streamSlice(set: NamedSet<ZustandStore>): StreamSlice {
	return {
		...streamInitialState(),
		setStreamData: (newData: GetEventsResponseObject) => {
			set(
				state => {
					state.stream.streamData.events = newData.events;
					state.stream.streamData.lastTimestamp = newData.lastTimestamp || state.stream.initialAfter;
					return state;
				},
				false,
				'[streamApi] setStreamData',
			);
		},
		setCurrentStreamData: (newData: GetEventsResponseObject) => {
			set(
				state => {
					state.stream.currentStreamData = newData;
					return state;
				},
				false,
				'[streamApi] setCurrentStreamData',
			);
		},
	};
}
